import { FloatingChat } from '@/components/FloatingChat';

/**
 * Renders the floating chat icon based on sponsor info from the token endpoint.
 * Use this in any user-facing module page.
 */
export function ModuleChat({ sponsorInfo }) {
  if (!sponsorInfo?.chat) return null;
  return <FloatingChat chatUrl={sponsorInfo.chat.url} enabled={sponsorInfo.chat.enabled} />;
}
